<svg width="100%"
     height="100%"
     viewBox="0 0 16 16"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     aria-hidden="true">
      <path id="Vector"
            d="M1.52991 1.53064L14.4687 14.4694"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round"
            stroke-linejoin="round" />
      <path id="Vector_2"
            d="M14.4691 1.5304L1.53036 14.4692"
            stroke="currentColor"
            stroke-width="2.3"
            stroke-linecap="round"
            stroke-linejoin="round" />
</svg>